import { motion } from 'framer-motion'
import { Clock, Shirt, Sparkles } from 'lucide-react'

const personas = [
    {
        icon: Clock,
        title: 'Busy mornings',
        description: "You don't have 15 minutes to decide what to wear. You need options, fast.",
    },
    {
        icon: Shirt,
        title: 'Closet full of "nothing to wear"',
        description: "You own plenty of clothes but keep reaching for the same 5 pieces.",
    },
    {
        icon: Sparkles,
        title: 'Want to look put-together',
        description: "You care about how you present yourself, but don't want to overthink it.",
    },
]

export function WhoItsFor() {
    return (
        <section className="py-20 sm:py-28 bg-paper">
            <div className="max-w-5xl mx-auto px-8 sm:px-6 lg:px-8">
                <div className="text-center mb-14 sm:mb-20">
                    <motion.h2
                        initial={{ opacity: 0, y: 12 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        className="font-display text-3xl sm:text-4xl font-semibold text-ink mb-4"
                    >
                        Sound familiar?
                    </motion.h2>
                    <motion.p
                        initial={{ opacity: 0, y: 12 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.1 }}
                        className="text-ink-tertiary text-lg max-w-xl mx-auto"
                    >
                        Michela is built for people who want to dress well without the daily mental effort.
                    </motion.p>
                </div>

                <div className="grid sm:grid-cols-3 gap-8 sm:gap-10">
                    {personas.map((persona, index) => (
                        <motion.div
                            key={persona.title}
                            initial={{ opacity: 0, y: 16 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: index * 0.1 }}
                            className="text-center sm:text-left"
                        >
                            <div className="inline-flex items-center justify-center w-12 h-12 mb-4 bg-paper-alt border border-paper-tertiary rounded-xl">
                                <persona.icon className="w-5 h-5 text-ink" strokeWidth={1.5} />
                            </div>
                            <h3 className="font-display text-lg font-semibold text-ink mb-2">
                                {persona.title}
                            </h3>
                            <p className="text-ink-tertiary text-[15px] leading-relaxed">
                                {persona.description}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default WhoItsFor
